import React from "react";
import { useState } from "react";

import { InputStyled } from "./Input.styled";

const Input = (props) => {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (value) => {
    setInputValue(value);
    props.getInputValue(value);
  };

  return (
    <>
      <InputStyled
        value={inputValue}
        title={props.title}
        onChange={(e) => handleInputChange(e.target.value)}
      ></InputStyled>
    </>
  );
};

export default Input;
